import { FC } from "react";
import ReportLayout from "../../components/Report/ReportLayout";
import {
  reportConsiderations as allReportConsiderations,
  TableSchema,
} from "../about/utils";
import { FilterType } from "../../types/filters.types";

interface RetailOpsReportProps {
  forceScreen?: "extraSmall" | "mobile" | "desktop";
  canScanBarcode?: boolean;
  loadFilters?: FilterType[];
}

const kpiDefinition: TableSchema[] = [
  {
    KPI: "Average Weekly Movment (AWM)",
    Definition:
      "Average of how much inventory we move in a week based on 26 weeks of historical sales",
    Formula: "Total Sales for 26 wks / 26",
  },
  {
    KPI: "Days of Supply",
    Definition:
      "# of days we expect to cover with available inventory based on 26 weeks of historical sales",
    Formula: "(Total Inventory / Total Sales for 26 wks) * 182",
  },
];

const reportConsiderations = [
  "A small portion (~1-2%) of products have incorrect CIC/CSC/UPC relationships, which may result in incorrect results when using the CIC or UPC filters",
  allReportConsiderations[2],
];

const RetailOpsReport: FC<RetailOpsReportProps> = ({
  forceScreen,
  canScanBarcode,
  loadFilters,
}) => (
  <ReportLayout
    forceScreen={forceScreen}
    canScanBarcode={canScanBarcode}
    isRetailOps
    loadFilters={loadFilters}
    kpiDefinition={kpiDefinition}
    reportConsiderations={reportConsiderations}
  />
);

export default RetailOpsReport;
